// Защита от устаревших ответов: актуален только последний запрос с данным ключом
const tokens = {};

export const takeLatest = (key) => {
  const token = Symbol(key);
  tokens[key] = token;
  return () => tokens[key] === token;
};
